import { ReactNode } from 'react';

import { Box } from '@mui/material';

type UserProfileContentWrapperProps = {
    children: ReactNode
}

export function UserProfileContentWrapper({ children }: Readonly<UserProfileContentWrapperProps>) {
    return (
        <div style={{ width: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    paddingTop: '25px'
                }}
            >
                {children}
            </Box>
        </div>
    );
}
